import { call, put, takeLatest } from "redux-saga/effects";
import {
  activeSubUserAction,
  addSubUserAction,
  deleteSubUserAction,
  getAllSubUserAction,
  getAllUserRolesAction,
  getResetPasswordAction,
  setAddSubUserResponse,
  setAllSubUserAction,
  setAllUserRolesAction,
  setConfirmationEmailSuccessAction,
  setDeleteSubUserResponse,
  setResetPasswordSuccessAction,
  setStaffConfirmationEmailAction,
  updateSubUserAction,
  updateSubUserResponse,
} from "../reducers/subUserSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllSubUserSaga(action: { payload: { status: string } }): any {
  const { status } = action.payload;
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/staffs?status=${status}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllSubUserAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getAllUserRolesSaga(): any {
  yield put(setLoaderAction(true));
  console.log("roles-try");
  try {
    const roles = yield call<any>(callAPI, {}, "get", "client/roles");
    console.log("roles-", roles);
    if (roles?.data) {
      yield put(setAllUserRolesAction(roles?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addSubUserSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/staffs",
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSubUserResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSubUserResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateSubUserSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { staff_id, status, created_at, updated_at,is_staff_email_signature_confirmed,staff_email_sender_signature_id, ...newPayload } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `client/staffs/${staff_id}`,
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updateSubUserResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(updateSubUserResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* activeSubUserSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { staff_id, created_at, updated_at, ...newPayload } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `client/staffs/${staff_id}`,
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updateSubUserResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(updateSubUserResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteSubUserSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { staff_id, status, created_at, updated_at, ...newPayload } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/staffs/${staff_id}`,
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteSubUserResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteSubUserResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getResetPasswordSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const staffId = action.payload?.staffId; // Directly access the payload
    console.log("staffId", staffId);
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/reset-password/${staffId}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setResetPasswordSuccessAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setResetPasswordSuccessAction(false));
  }
  yield put(setLoaderAction(false));
}

//   send confirmation action
function* setStaffConfirmationEmailSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { staffId, ...newPayload } = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `client/staffs/${staffId}/sender-signature`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setConfirmationEmailSuccessAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setConfirmationEmailSuccessAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchSubUser() {
  yield takeLatest<any>(getAllSubUserAction, getAllSubUserSaga);
  yield takeLatest<any>(getAllUserRolesAction, getAllUserRolesSaga);
  yield takeLatest<any>(addSubUserAction, addSubUserSaga);
  yield takeLatest<any>(updateSubUserAction, updateSubUserSaga);
  yield takeLatest<any>(deleteSubUserAction, deleteSubUserSaga);
  yield takeLatest<any>(getResetPasswordAction, getResetPasswordSaga);
  yield takeLatest<any>(activeSubUserAction, activeSubUserSaga);
  yield takeLatest<any>(
    setStaffConfirmationEmailAction,
    setStaffConfirmationEmailSaga,
  );
}
